import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare global {
  interface Window {
    _vwo_code?: any;
    VWO?: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class VwoService {
  constructor(private router: Router) {}

  init(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.trackPageView();
      });
  }

  private trackPageView(retries = 3): void {
    if (window.VWO && typeof window.VWO.push === 'function') {
      window.VWO?.push([
        'activate',
        {
          customUrl: window.location.href,
        },
      ]);
    } else if (window.VWO && retries > 0) {
      setTimeout(() => this.trackPageView(retries - 1), 500);
    } else {
      console.warn('VWO not available.');
    }
  }

  triggerEvent(eventName: string, eventProps?: any): void {
    if (window.VWO && typeof window.VWO.event === 'function') {
      window.VWO.event(eventName, eventProps || {});
    }
  }
}